import React from 'react'

export default function MailingAddress({ ...props }) {
	return (
		<span {...props}>
			480 Norristown Road <br /> Blue Bell, PA 19422
		</span>
	)
}
